import { render, staticRenderFns } from "./PostTransaction.vue?vue&type=template&id=90442406"
import script from "./PostTransaction.vue?vue&type=script&lang=js"
export * from "./PostTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports